module.exports = __webpack_public_path__ + "img/2007.7d0db73d.jpg";